module.exports = __webpack_public_path__ + "static/media/First Crush-01.548faa95.svg";